// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1mH3e","dot":"_28JdH","tooltip-content":"_1OW0g","tooltipContent":"_1OW0g"};